import { BaseAPI } from 'API/BaseApi';
import { ITransferDeedResponse } from '../../../types/title/ITransferDeedResponse';
import { ICreateUpdateTransferDeedRequest } from '../../../types/title/ICreateUpdateTransferDeedRequest';
import { eAPITags } from '../../eAPITags';

export const TransferDeedApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getTransferDeed: build.query<ITransferDeedResponse, { orderId: string }>({
      query: ({ orderId }) => ({
        url: `/timber/api/internal/orders/${orderId}/transfer_deeds`,
        method: 'GET',
      }),
      providesTags: (response, error, { orderId }) => [{ type: eAPITags.TransferDeed, id: orderId }],
    }),
    createTransferDeed: build.mutation<
      ITransferDeedResponse,
      { orderId: string; data: ICreateUpdateTransferDeedRequest }
    >({
      query: ({ orderId, data }) => ({
        url: `/timber/api/internal/orders/${orderId}/transfer_deeds`,
        method: 'POST',
        body: data,
      }),
      transformResponse: (response: ITransferDeedResponse) => response,
      invalidatesTags: (response, error, { orderId }) => [{ type: eAPITags.TransferDeed, id: orderId }],
    }),
    updateTransferDeed: build.mutation<
      ITransferDeedResponse,
      { id: string; orderId: string; data: ICreateUpdateTransferDeedRequest }
    >({
      query: ({ id, orderId, data }) => ({
        url: `/timber/api/internal/orders/${orderId}/transfer_deeds/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (response, error, { orderId }) => [{ type: eAPITags.TransferDeed, id: orderId }],
    }),
  }),
});

export const { useGetTransferDeedQuery, useCreateTransferDeedMutation, useUpdateTransferDeedMutation } =
  TransferDeedApi;
